export class BaseModel {
    public id?: number;
    public createdBy: string;
    public createdOn?: Date | string;
    public modifiedBy: string;
    public modifiedOn?: Date | string | null;
    public isDeleted?: boolean;
    public deletedBy?: string;
    public deletedOn?: Date | string | null;
}

export class ModelType extends BaseModel {
    name: string;
    variantCode: string;
    variantProviderText: string;
}

export class TireSize extends BaseModel {
    modelTypeId: number;
    name: string;
}

export class ProviderLocation {
    providerID: number;
    name: string;
    supplierCode: string;
    locationId: number;
    dispatchPhoneNumber: string;
    dispatchEmail: string;
    addressID: number;
    address: Address;
}

export class Address {
    addressId: number;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    city: string;
    province: string;
    postalCode: string;
    countryCode: string;
}

export class Inventory extends BaseModel{
    id: number;
    supplierCode: string;
    locationId: string;
    modelTypeId: number;
    tireSizeId: number;
    quantity: number
}

export class InventoryHistory{
    modifiedBy: string;
    modifiedOn?: Date | string | null;
    locationId: string;
    modelTypeId: number;
    tireSizeId: number;
    previousQuantity: number;
    updatedQuantity: number;
    startTime?: Date | string | null;
}